/**
 * Houses all the Ids assigned to the specific elements of this application DOM.
 */
class ElementIds {
    static appId: string = 'app-element-id';

    static panel = {
        appBar: 'panel-appbar-id',
        main: 'panel-main-id',
        footer: 'panel-footer-id',
    } as const;
}

export default ElementIds;
